import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { HttpService } from '@services/http.service';

import { EndpointParams } from '@models/utils/endpoint-params';
import { Category } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class CategoriesService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    private categoriesSubject = new BehaviorSubject<Category[]>([]);
    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { categories: Category[] } = { categories: [] };

    get categories(): Observable<Category[]> {
        return this.categoriesSubject.asObservable();
    }

    get isLoading(): Observable<boolean> {
        return this.isLoadingSubject.asObservable();
    }

    list(): void {
        this.loading(true);
        this.listCategories().subscribe(
            () => {
                this.next();
                this.loading(false);
            }
        );
    }

    search(idPackCategory: number): void {
        this.loading(true);
        this.get(`polaris/virtual/categories/${idPackCategory}`, this.defaultEndpointParams).subscribe(
            data => {
                const index: number = this.dataStore.categories.findIndex(c => c.idPackCategory === idPackCategory);
                if (index > -1) {
                    this.dataStore.categories[index] = new Category().build(data);
                } else {
                    this.dataStore.categories.push(new Category().build(data));
                }

                this.next();
                this.loading(false);
            }
        );
    }

    private listCategories(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get('polaris/virtual', this.defaultEndpointParams).subscribe(
                    res => {
                        if (res) {
                            this.dataStore.categories = [];
                            res.categories.forEach((category: any) => {
                                this.dataStore.categories.push(new Category().build(category));
                            });
                        }
                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(): void {
        this.categoriesSubject.next([ ...this.dataStore.categories ]);
    }

    private loading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
